var MuiStepLabel = {
    label: {
        marginBottom: 0,
    },
    iconContainer: {
        paddingRight: 10,
    },
};
export default MuiStepLabel;
//# sourceMappingURL=MuiStepLabel.js.map